const Endpoints = {
  LOGIN: '/api/login',
  LOGOUT: '/api/logout',

  GET_OWN_ORGANISATIONS_AND_SITES: '/api/ownOrganisationsAndSites',
  GET_VISITOR_ANALYTICS: (date: string, organisationId: string, siteId: string) => `/api/dashboard/visitorAnalytics?date=${date}&organisation=${organisationId}&site=${siteId}`,
  GET_SITE_HOURLY_AVG_INSIDERS_FOR_MONTH: (date: string, organisationId: string, siteId: string) => `/api/dashboard/siteHourlyAvgInsidersForMonth?date=${date}&organisation=${organisationId}&site=${siteId}`,
  GET_SITE_HOURLY_AVG_VISITORS_FOR_MONTH: (date: string, organisationId: string, siteId: string) => `/api/dashboard/siteHourlyAvgVisitorsForMonth?date=${date}&organisation=${organisationId}&site=${siteId}`,
  GET_SITE_VISITORS_PER_MONTH: (date: string, organisationId: string, siteId: string) => `/api/dashboard/siteVisitorsPerMonth?date=${date}&organisation=${organisationId}&site=${siteId}`,
  GET_SITE_VISITORS_PER_WEEK: (date: string, organisationId: string, siteId: string) => `/api/dashboard/siteVisitorsPerWeek?date=${date}&organisation=${organisationId}&site=${siteId}`,
  GET_SITE_VISITORS_PER_DAY: (date: string, organisationId: string, siteId: string) => `/api/dashboard/siteVisitorsPerDay?date=${date}&organisation=${organisationId}&site=${siteId}`,

  GET_LIVE_VIEW: '/api/live-view',

  GET_STATISTICS: '/api/statistics/query',
  EXPORT_STATISTICS: '/api/statistics/export',

  GET_SETTINGS: '/api/settings/site',
  SAVE_SETTINGS: (siteId: string) => `/api/settings/site/${siteId}`,

  ORGANISATIONS: '/api/admin/organisations',
  ORGANISATION: (id: number) => `/api/admin/organisations/${id}`,
  SITES: '/api/admin/sites',
  SITE: (id: number) => `/api/admin/sites/${id}`,
  SENSORS: '/api/admin/sensors',
  SENSOR: (id: number) => `/api/admin/sensors/${id}`,
  USERS: '/api/admin/users',
  USER: (id: number) => `/api/admin/user/${id}`,
};

export default Endpoints;
